<template>
<div class="c-panel c-panel--border c-panel--no-shadow margin-b-24">
		<h4>{{client.name}}</h4>
		<div class="fs-small color-gray-500 margin-b-16">Aangemaakt op: {{datetime(client.created_at)}}</div>

		<c-splitbutton class="margin-b-24" :buttons="buttons" v-if="user.contact.client.client_type_id !== $constants.client.EINDKLANT"></c-splitbutton>

		<c-splitbutton v-if="isAdminAndClientTypeEndUser" class="margin-b-24 margin-l-8" :buttons="buttons2" :buttonText="'Ticket aanmelden'" dropDownOnly></c-splitbutton>

		<div v-if="client.client_type_id !== $constants.client.EINDGEBRUIKER" class=" margin-b-16 fs-xsmall">
			<div class="columns small-12 medium-4">
				<span class="color-gray-600 font-heading">Bezoekadres</span>
			</div>
			<div class="columns small-12 medium-8" v-if="client.visiting_address">
				{{client.visiting_address.street}} {{client.visiting_address.number}}, {{client.visiting_address.city}}
			</div>
		</div>

		<h6 class="margin-b-24 margin-t-40">Contactpersonen</h6>
        <div class="row">
            <div class="columns small-6 margin-b-32" v-for="contact in client.contacts">
                <div class="font-heading margin-b-8 fw-bold">
                    {{contact.first_name}} {{contact.last_name}}
                </div>
                <div class="color-gray-600">
                    {{contact.title}}<br />
                    {{contact.phone}}<br />
                    {{contact.email}}<br />
                    <template v-if="can('Klant wijzigen') && client.client_type_id !== this.$constants.client.EINDGEBRUIKER">
                        <a href="#" class="color-secondary" @click.prevent="editContact(contact.id)">Wijzigen</a> /
                        <a href="#" class="color-secondary" @click.prevent="openRemoveContactModal(contact.id)">verwijderen</a>
                    </template>
                </div>
            </div>
        </div>

		<div class="c-stock__button margin-t-24" v-if="client.client_type_id === $constants.client.REUZADO || client.client_type_id === $constants.client.RESELLER || client.client_type_id === $constants.client.EINDKLANT" @click="trigger('add-contacts')">
			<button class="c-btn c-btn--hollow no-margin">
				{{client.id === 1 ? 'Medewerker toevoegen' : 'Contactpersoon toevoegen'}}
			</button>
		</div>

		</div>
		<c-remove-customer
			:contact="editingContact"
			v-show="modalRemoveCustomer"
			@close="modalRemoveCustomer = false"
            @close:confirm="trigger('refresh-client-data')"
			:size="'tiny'">
		</c-remove-customer>

		<c-add-contacts v-if="client.end_clients"
			:endclients="client.end_clients"
			:contact="client"
			v-show="addcontacts"
            :data="editingContact"
            @submit:success="trigger('refresh-client-data')"
			@close="closeContactModal"
			:size="'medium'"
			:client_id="client.id">
		</c-add-contacts>

		<c-remove
			v-show="removeUserModal"
			:size="'medium'"
			:text="this.type"
			@close="removeUserModal=false"
			@remove="removeUser()">
		</c-remove>

</template>

<script>
import CSplitbutton from '@components/Splitbutton';
import CRemoveCustomer from '@app/modals/RemoveCustomer';
import CAddContacts from '@app/modals/AddContacts';
import CRemove from '@app/modals/Remove';

import { mapGetters } from 'vuex';
import user from '../../store/modules/user';

export default {
	components: { CSplitbutton, CRemoveCustomer, CAddContacts, CRemove },
	props: {
		client: {
			type: Object,
			required: true
		},
	},
	data() {
        return {
			modalRemoveCustomer: false,
			modal: false,
			name: false,
			addcontacts: false,
			removeUserModal: false,
            editingContact: {}
		}
	},
	methods : {
		openModalRemoveCustomer() {
			this.modalRemoveCustomer = true;
		},
		openModalRemoveUser() {
			this.removeUserModal = true;
		},
        editContact(id){
            this.addcontacts = true
            this.editingContact = this.client.contacts.find(contact => contact.id === id)
        },
        closeContactModal(){
            this.addcontacts = false
            this.editingContact = {}
        },
		datetime(value){
			if ( typeof value == 'string' && value.trim() != '' ) {
				let date = new Date(value);

				if ( isNaN(date.getTime()) === false ) {

					return date.toLocaleDateString('nl-NL', {day: 'numeric', month:'numeric', year: 'numeric'})

				}
    		}
		},
		trigger(event) {
           this.$store.dispatch('listener/emit', event);
		},
		openModal() {
			this.modal = true;
		},
		openAddContacts(){
			this.addcontacts = true;
		},
        openRemoveContactModal(id){
            this.editingContact = this.client.contacts.find(contact => contact.id === id)
            this.modalRemoveCustomer = true;
        },
        removeContact(){
            this.$xhr.delete('/api/contacts/' + this.editingContact.id).then( ( {result}) => {
                this.$store.dispatch('toast/success', {title: 'Contactpersoon verwijderen', text: 'Contactpersoon is verwijderd'});
                close();
            }).catch( (e) => {
                this.$store.dispatch('toast/alert', {title: 'Contactpersoon verwijderen', text: 'Er is helaas iets fout gegaan bij het verwijderen'});
            });

        },
		removeUser(){
            this.$xhr.delete('/api/clients/' + this.client.id).then( ( {result}) => {
				this.$store.dispatch('toast/success', {title: this.type + ' verwijderen', text: this.type + ' is verwijderd'});
                close();
                window.location.replace("/");
			}).catch( (e) => {
                    this.$store.dispatch('toast/alert', {title: this.type +' verwijderen', text: 'Er is helaas iets fout gegaan bij het verwijderen'});
			});
		}
	},
	created() {
		this.$store.dispatch('listener/on', {
			listener: this.openModalRemoveCustomer
		});
		this.$store.dispatch('listener/on', {
			listener: this.openModalRemoveUser
		});

		this.$store.dispatch('listener/on', {
			event: 'add-contacts',
			listener: this.openAddContacts
		});
	},
	beforeUnmount() {
		this.$store.dispatch('listener/off', {
			listener: this.openModalRemoveCustomer
		});
		this.$store.dispatch('listener/off', {
			listener: this.openModalRemoveUser
		});
	},
	computed: {
        type(){
            return this.$constants.getClientTypeWithId(this.client.client_type_id);
        },
		buttons() {
			let buttons = [];
			this.can('Klant wijzigen') && buttons.push({
				label: 'Bewerken',
				action: () => {
					this.trigger('new-customer')
				},
			});

			this.can('Klant verwijderen') && buttons.push({
				label: this.type + ' verwijderen',
				action: () => {
					this.openModalRemoveUser();
				},
			});

			return buttons;
		},
        isAdminAndClientTypeEndUser(){
            return this.client?.client_type_id === 4 && this.can('Klant wijzigen') && this.can('Levering aanmaken');
        },
        buttons2(){
            const buttons = [];

            buttons.push({
                label: 'Uitdiensttreding',
                action: () => {
                    this.trigger('resignation')
                },
            });

            buttons.push({
                label: 'Reparatieverzoek',
                action: () => {
                    this.trigger('repair')
                },
            });

            buttons.push({
                label: 'EOL swap',
                action: () => {
                    this.trigger('eol-swap')
                },
            });

            buttons.push({
                label: 'Extra bestellen',
                action: () => {
                    this.trigger('extra-products')
                },
            });

            return buttons;
        },
		...mapGetters({
			can: 'user/can',
			user: 'user/get'
		})

	},
}
</script>
